export default {"src":"/_next/static/media/search.d1fcd6f5.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};